(() => {
  const initialize = (root) => {
    if (!root || root.dataset.pklInitialized === 'true') return;
    root.dataset.pklInitialized = 'true';
    root.classList.add('pkl--animate');

    const starterBalls = [...root.querySelectorAll('.pkl__starter-ball')];
    const starterCard = root.querySelector('[data-pkl-starter-card]');
    let selectedStarter = starterBalls.find((ball) => ball.getAttribute('aria-pressed') === 'true')?.dataset.pklStarter || 'bulbasaur';
    const showStarter = (starter) => {
      if (starterCard && starter) starterCard.dataset.starter = starter;
    };
    const showOpenBall = (activeBall) => {
      starterBalls.forEach((item) => item.classList.toggle('is-open', item === activeBall));
      showStarter(activeBall?.dataset.pklStarter || selectedStarter);
    };
    const selectedBall = () => starterBalls.find((item) => item.dataset.pklStarter === selectedStarter);
    starterBalls.forEach((ball) => {
      ball.addEventListener('click', () => {
        selectedStarter = ball.dataset.pklStarter;
        starterBalls.forEach((item) => {
          item.setAttribute('aria-pressed', 'false');
        });
        ball.setAttribute('aria-pressed', 'true');
        showOpenBall(ball);
      });
      ball.addEventListener('pointerenter', () => showOpenBall(ball));
      ball.addEventListener('focus', () => showOpenBall(ball));
      ball.addEventListener('pointerleave', () => showOpenBall(selectedBall()));
      ball.addEventListener('blur', () => showOpenBall(selectedBall()));
    });
    showOpenBall(selectedBall());

    const languageCompare = root.querySelector('[data-pkl-language-compare]');
    const languageRange = languageCompare?.querySelector('[data-pkl-language-range]');
    const languagePairButtons = [...root.querySelectorAll('[data-pkl-language-pair]')];

    if (languageCompare && languageRange) {
      const leftCard = languageCompare.querySelector('[data-pkl-card-left]');
      const rightCard = languageCompare.querySelector('[data-pkl-card-right]');
      const leftLabel = languageCompare.querySelector('[data-pkl-label-left]');
      const rightLabel = languageCompare.querySelector('[data-pkl-label-right]');
      const languages = {
        english: {
          label: 'English',
          spokenLabel: 'Englisch',
          src: languageCompare.dataset.pklEnglishSrc,
          alt: 'Umbreon VMAX Pokémon-Karte auf Englisch'
        },
        german: {
          label: 'Deutsch',
          spokenLabel: 'Deutsch',
          src: languageCompare.dataset.pklGermanSrc,
          alt: 'Nachtara VMAX Pokémon-Karte auf Deutsch'
        },
        chinese: {
          label: 'Simplified Chinese',
          spokenLabel: 'vereinfachtes Chinesisch',
          src: languageCompare.dataset.pklChineseSrc,
          alt: 'Umbreon VMAX Pokémon-Karte in Simplified Chinese'
        }
      };
      let currentPair = { left: languages.english, right: languages.chinese };

      Object.values(languages).forEach((language) => {
        if (!language.src) return;
        const image = new Image();
        image.src = language.src;
      });

      const updateLanguageComparison = (value) => {
        const position = Math.max(0, Math.min(100, Number(value)));
        languageRange.value = String(position);
        languageCompare.style.setProperty('--pkl-language-position', `${position}%`);
        languageRange.setAttribute(
          'aria-valuetext',
          position === 0
            ? currentPair.right.spokenLabel
            : position === 100
              ? currentPair.left.spokenLabel
              : `${position} Prozent ${currentPair.left.spokenLabel}, ${100 - position} Prozent ${currentPair.right.spokenLabel}`
        );
      };

      const selectLanguagePair = (button) => {
        if (!button) return;
        const left = languages[button.dataset.pklPairLeft];
        const right = languages[button.dataset.pklPairRight];
        if (!left || !right || !leftCard || !rightCard || !leftLabel || !rightLabel) return;

        currentPair = { left, right };
        leftCard.src = left.src;
        leftCard.alt = left.alt;
        rightCard.src = right.src;
        rightCard.alt = right.alt;
        leftLabel.textContent = left.label;
        rightLabel.textContent = right.label;
        languageRange.setAttribute('aria-label', `Vergleich zwischen ${left.spokenLabel} und ${right.spokenLabel}`);
        languagePairButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        updateLanguageComparison(50);
      };

      languageRange.addEventListener('input', (event) => updateLanguageComparison(event.target.value));
      languagePairButtons.forEach((button) => {
        button.addEventListener('click', () => selectLanguagePair(button));
      });
      selectLanguagePair(languagePairButtons.find((button) => button.getAttribute('aria-pressed') === 'true') || languagePairButtons[0]);
    }

    const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const catcher = root.querySelector('[data-pkl-catcher]');
    const catcherBall = catcher?.querySelector('.pkl__catch-ball');
    const roamingPokemon = [...root.querySelectorAll('[data-pkl-pokemon]')];

    if (!motionReduced && catcher && catcherBall && roamingPokemon.length) {
      let catching = false;
      let lastCheck = 0;

      const centerOf = (rect) => ({
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
      });

      const respawn = (pokemon) => {
        const ballRect = catcherBall.getBoundingClientRect();
        const pokemonImage = pokemon.querySelector('.pkl__orbit-upright img');
        const pokemonRect = pokemonImage.getBoundingClientRect();
        const ballCenter = centerOf(ballRect);
        const pokemonCenter = centerOf(pokemonRect);
        const image = pokemonImage;

        image?.style.setProperty('--pkl-spawn-x', `${ballCenter.x - pokemonCenter.x}px`);
        image?.style.setProperty('--pkl-spawn-y', `${ballCenter.y - pokemonCenter.y}px`);
        catcher.classList.remove('is-occupied');
        catcher.classList.add('is-spawning');
        pokemon.classList.remove('is-caught');
        pokemon.classList.add('is-respawning');

        window.setTimeout(() => catcher.classList.remove('is-spawning'), 620);
        window.setTimeout(() => {
          pokemon.classList.remove('is-respawning');
          pokemon.dataset.pklCooldownUntil = String(performance.now() + 2400);
          window.setTimeout(() => {
            catching = false;
          }, 1500);
        }, 980);
      };

      const capture = (pokemon) => {
        catching = true;
        catcher.classList.add('is-catching');
        pokemon.classList.add('is-caught');
        window.setTimeout(() => catcher.classList.remove('is-catching'), 620);
        window.setTimeout(() => catcher.classList.add('is-occupied'), 840);
        window.setTimeout(() => respawn(pokemon), 2340);
      };

      const detectCollisions = (time) => {
        if (!root.isConnected) return;

        if (!catching && !document.hidden && time - lastCheck > 80) {
          lastCheck = time;
          const ballRect = catcherBall.getBoundingClientRect();
          const ballCenter = centerOf(ballRect);

          for (const pokemon of roamingPokemon) {
            if (Number(pokemon.dataset.pklCooldownUntil || 0) > time) continue;
            const pokemonRect = pokemon.querySelector('.pkl__orbit-upright img').getBoundingClientRect();
            const pokemonCenter = centerOf(pokemonRect);
            const distance = Math.hypot(ballCenter.x - pokemonCenter.x, ballCenter.y - pokemonCenter.y);
            const captureDistance = (ballRect.width + pokemonRect.width) * .28;
            if (distance < captureDistance) {
              capture(pokemon);
              break;
            }
          }
        }

        window.requestAnimationFrame(detectCollisions);
      };

      window.requestAnimationFrame(detectCollisions);
    }

    const items = root.querySelectorAll('[data-pkl-reveal]');

    if (!('IntersectionObserver' in window) || motionReduced) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -24px' });

    items.forEach((item) => observer.observe(item));
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-pkl]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
